import { TItem } from '../types'
import ELocale from '../../../types/locales'

const itemExistsInLocale = (item: TItem, locale: ELocale): boolean => {
  return (item.hideIn?.indexOf(locale) ?? -1) == -1
}

export default itemExistsInLocale
